export default __webpack_public_path__ + "img/bg-655a3fd5.png";